// -------------------------------------
// Product Card Swatches
// -------------------------------------

// export changeSwatch function from iamCardSwatches
export function changeSwatch(swatchOption) {
    // Variables
    const CARD_PRODUCT        = '.card--product';
    const CARD_IMAGE_WRAPPER  = '.card__image-wrapper .card__image--primary';
    const CARD_IMAGE_WRAPPER2  = '.card__image-wrapper .card__image--secondary';
    const CARD_PRODUCT_IMAGE  = '.card__product-image.image--primary';
    const CARD_PRODUCT_IMAGE2  = '.card__product-image.image--secondary';
    const CARD_COLOR_SWATCHES = '.card__color-swatches';

    const SELECTED_CLASS_NAME = 'selected';
    // Update selected state
    if (!swatchOption.classList.contains(SELECTED_CLASS_NAME)) {
        const cardContent = swatchOption.closest('.card__content');
        const cardLink = cardContent.querySelector('.card__link');
        cardLink.href = swatchOption.dataset.swatchUrl;


        const cardColorSwatches = swatchOption.closest(CARD_COLOR_SWATCHES);
        const selectedSwatchOption = cardColorSwatches.querySelector(`.${SELECTED_CLASS_NAME}`);
        selectedSwatchOption.classList.remove(SELECTED_CLASS_NAME);
        swatchOption.classList.add(SELECTED_CLASS_NAME);


        const newImageSrc = swatchOption.dataset.imageSrc;
        const newImageSrc2 = swatchOption.dataset.imageSrc2;

        if (newImageSrc !== undefined) {
            // Get additional src and srcset
            const newDesktopMedia  = swatchOption.dataset.desktopMedia;
            const newDesktopSrcset = swatchOption.dataset.desktopSrcset;
            const newMobileSrcset  = swatchOption.dataset.mobileSrcset;
            const newImageSrcset   = swatchOption.dataset.imageSrcset;

            const productCard             = swatchOption.closest(CARD_PRODUCT);
            const productCardImageWrapper = productCard.querySelector(CARD_IMAGE_WRAPPER);
            const productCardPicture      = productCardImageWrapper.querySelector('picture');
            const productCardPictureImage = productCardPicture.querySelector(CARD_PRODUCT_IMAGE);

            // Update desktop and mobile src
            productCardPicture.querySelectorAll('source')
                .forEach((source, index) => {

                    switch (index) {
                        case 0:
                            // Desktop Source
                            source.media  = newDesktopMedia;
                            source.srcset = newDesktopSrcset;
                            break;
                        case 1:
                            // Mobile Source
                            source.srcset = newMobileSrcset;
                            break;
                        default:
                            break;
                    }
                });

            // Update image src
            productCardPictureImage.src    = newImageSrc;
            productCardPictureImage.srcset = newImageSrcset;
        }

        if (newImageSrc2 !== undefined) {
            // Get additional src and srcset
            const newDesktopMedia2  = swatchOption.dataset.desktopMedia2;
            const newDesktopSrcset2 = swatchOption.dataset.desktopSrcset2;
            const newMobileSrcset2  = swatchOption.dataset.mobileSrcset2;
            const newImageSrcset2   = swatchOption.dataset.imageSrcset2;

            const productCard             = swatchOption.closest(CARD_PRODUCT);
            const productCardImageWrapper2 = productCard.querySelector(CARD_IMAGE_WRAPPER2);
            const productCardPicture2      = productCardImageWrapper2.querySelector('picture');
            const productCardPictureImage2 = productCardPicture2.querySelector(CARD_PRODUCT_IMAGE2);

            // Update desktop and mobile src
            productCardPicture2.querySelectorAll('source')
                .forEach((source, index) => {

                    switch (index) {
                        case 0:
                            // Desktop Source
                            source.media  = newDesktopMedia2;
                            source.srcset = newDesktopSrcset2;
                            break;
                        case 1:
                            // Mobile Source
                            source.srcset = newMobileSrcset2;
                            break;
                        default:
                            break;
                    }
                });

            // Update image src
            productCardPictureImage2.src    = newImageSrc2;
            productCardPictureImage2.srcset = newImageSrcset2;
        }
    }
}

// export listenForImageEvents function from iamCardSwatches
export function listenForImageEvents(productCard) {
    const cardLink = productCard.querySelector('.card__link');
    const imageWrapper = productCard.querySelector('.card__image-wrapper');

    if (window.innerWidth > 1024) {
        if (window.matchMedia && window.matchMedia('(pointer:coarse)').matches) {
            /* if the pointer is coarse, listen to touch events */

            // cardLink.addEventListener('touchstart', () => {
            //     imageWrapper.classList.add('hover');
            // });
            // cardLink.addEventListener('touchend', () => {
            //     imageWrapper.classList.remove('hover');
            // });
        } else {
            /* otherwise, listen to mouse and keyboard events */

            cardLink.addEventListener('mouseover', () => {
                imageWrapper.classList.add('hover');
            });
            cardLink.addEventListener('mouseout', () => {
                imageWrapper.classList.remove('hover');
            });
        }
    }
}
